import StubPage from '../../components/StubPage.jsx';

export default function CollaborationPage() {
  return (
    <StubPage
      title="Collaboration"
      description="Invite teammates and clients. Comment, review, and hand off."
      planned={[
        'Invite teammates by email with role-based permissions',
        'Multi-user live editing with presence cursors',
        'Per-block comments and resolve flow',
        'Client handoff mode (locked editing, branded preview link)',
      ]}
    />
  );
}
